import { Box, Typography } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { IMessageListItem } from "source/models/message/messageListItem";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { ForwardToolButton } from "source/components/framework/Button/ForwardToolButton";
import { EditToolButton } from "source/components/framework/Button/EditToolButton";
import { ListStateIconLocked } from "source/components/framework/List/ListStateIconLocked";
import { ListStateIconUnread } from "source/components/framework/List/ListStateIconUnread";

interface IMessageListHeaderProps {
    item: IMessageListItem;
    canEditMessages: boolean;
    editMode: boolean;
    onForwardMessage: (messageId: string) => void;
    onOpenMessage: (messageId: string) => void;
}

export const MessageListHeader = ({ item, canEditMessages, editMode, onForwardMessage, onOpenMessage }: IMessageListHeaderProps) => {
    return (
        <Box sx={{ display: "flex", alignItems: "center", paddingBottom: "10px" }}>
            <AvatarImage
                size={60}
                id={item.modifyUser.code}
                name={item.modifyUser.name}
                image={item.modifyUser.picture}
                tooltip={item.modifyUser.name}
            />
            <Box sx={{ paddingLeft: "20px", width: "100%" }}>
                <Box sx={{ display: "flex", alignItems: "start" }}>
                    <Typography variant="h4">{item.title}</Typography>
                    <Box display="flex" sx={{ alignItems: "center", marginLeft: "auto" }}>
                        <Typography sx={{ marginRight: "10px" }}>{Base.utcTimeToDateStr(item.date)}</Typography>
                        <AvatarImage
                            image={item.typeImage}
                            tooltip={item.typeName}
                        />
                        <ListStateIconUnread unread={!item.isRead && !item.requiresReceiptIsRead} />
                        <ListStateIconLocked locked={editMode && item.locked} />
                        {canEditMessages &&
                            <ForwardToolButton onClick={() => onForwardMessage(item.id)} />
                        }
                        {editMode &&
                            <EditToolButton onClick={() => onOpenMessage(item.id)} />
                        }
                    </Box>
                </Box>
                <Typography variant="caption" sx={{ color: "text.secondary", fontSize: ".85rem" }}>{Translations.Publisher + ": " + item.companyName + " / " + item.modifyUser.name}</Typography>
                {item.expired &&
                    <Typography sx={{ color: "error.main", fontSize: ".85rem" }}>{Translations.MessageVisibilityPeriodNotActive}</Typography>
                }
                {item.notVisibleYet &&
                    <Typography sx={{ color: "error.main", fontSize: ".85rem" }}>{Translations.MessageVisibilityPeriodNotStarted}</Typography>
                }
            </Box>
        </Box>
    );
};
